import { useLocation } from "react-router-dom";
import { getPrivacyAppName } from "../../Utils/privacyPolicy";
import React, { useEffect } from "react";
import "../../Assets/Styles/pages/landingRedesign.scss";
import "../../Assets/Styles/pages/pricingPageRedesign.scss";
import Nav from "../../Components/LandingComponents/Nav";

import Privacy from "../../Components/PrivacyComponents/privacy";
import usePageMetadata from "../../Utils/usePageMetadata";
import { useTranslation } from "react-i18next";

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation();
  const { search } = useLocation();
  const appName = getPrivacyAppName(search);
  const policyName = appName || "eZy WaterMark";

  usePageMetadata(
    `Privacy Policy - ${policyName}`,
    `Read the Privacy Policy for ${policyName}. Learn how we collect, use, and protect your information.`
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-redesign">
      {!appName && <Nav />}
      <section className="pp-hero lr-grain">
        <div className="pp-hero__orbs">
          <div className="pp-hero__orb pp-hero__orb--1" />
          <div className="pp-hero__orb pp-hero__orb--2" />
        </div>

        <div className="pp-hero__content">
          <span className="pp-hero__badge">
            <span />
            {t("PrivacyTitle")}
          </span>
          <h1 className="pp-hero__title">
            <span className="lr-hero-word" style={{ animationDelay: "0.05s" }}>
              <span className="lr-text-gradient">Our Privacy</span>
            </span>{" "}
            <span className="lr-hero-word" style={{ animationDelay: "0.2s" }}>
              <span className="lr-text-gradient">Commitment</span>
            </span>
          </h1>
          <p className="pp-hero__subtitle">{appName ? `Privacy Policy for ${appName}` : "How we collect, use, and protect your information."}</p>
        </div>
      </section>
      <Privacy appName={appName} />
    </div>
  );
};

export default PrivacyPolicy;
